import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      id: 0,
      cedula: '',
      tipo: false,
      nombre: '',
      ciaPorDefecto: '',
    },
    strCaseId: 0,
    strCia: "",
  },
  mutations: {
    setUser(state, value) {
      state.user = value
    },
    setStrCaseId(state, value) {
      state.strCaseId = value
    },
    setStrCia(state, value) {
      state.strCia = value
    }
  },
  actions: {
  },
  getters: {
    user: state => state.user,
    strCaseId: state => state.strCaseId,
    strCia: state => state.strCia
  }
})
